import { useContext } from 'react';
import { EnvironmentContext } from '../contexts/EnvironmentContext';

export const useEnvironment = () => useContext(EnvironmentContext);
